import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppHttpInterceptor } from '@core/interceptors/app.interceptor';
import { CargoApiInterceptor } from '@core/interceptors/cargoapi.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';

import { SharedModule } from '@shared/index';
import { CoreModule } from '@core/index';
import { RouterModule } from '@angular/router';
import { MatNativeDateModule, MatProgressBarModule } from '@angular/material';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgbModule,NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';
import { CarouselModule } from 'ngx-bootstrap/carousel';

// import { CalibrationComponent } from './features/calibration/calibration/calibration.component';
// import { CameraStreamingComponent } from './features/camera-streaming/camera-streaming/camera-streaming.component';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#2C9EFF',
  pbColor: '#2C9EFF',
  fgsType: 'fading-circle'
};
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CarouselModule.forRoot(),
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule,
    NgxSpinnerModule,
    CoreModule,
    MatNativeDateModule,
    MatProgressBarModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgbModule,
    NgbPaginationModule
  ],
  exports: [RouterModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    ...(environment.NOSQL_INTERCEPTOR==="true"?[{provide: HTTP_INTERCEPTORS, useClass: CargoApiInterceptor, multi: true}]:[])
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
